export const patientItem = {
    title: 'Accéder au dossier patient de {first_name} {last_name}',
    no_contact: 'Aucun contact renseigné',
    blacklisted: "blacklisté",
    deceased: "décédé",
    colleague: "un collègue"
}